// ─── useEngineStatus ────────────────────────────────────────
// Polls the module-level engine singletons on a short interval and exposes
// the latest snapshot to React. Used by the login-page status indicator so
// the lights stay live while the user sits on the login screen.

import { useEffect, useState } from 'react';
import { getEngineStatus, type EngineStatus } from '@/lib/engine-status';

const DEFAULT_INTERVAL_MS = 1500;

export function useEngineStatus(intervalMs: number = DEFAULT_INTERVAL_MS): EngineStatus {
  const [status, setStatus] = useState<EngineStatus>(() => getEngineStatus());

  useEffect(() => {
    const tick = () => setStatus(getEngineStatus());
    tick();
    const timer = setInterval(tick, intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return status;
}